const escapeCsvField = (field: string) => {
	if (field.includes(",") || field.includes("\n") || field.includes('"')) {
		// Double up any double quotes in the field
		field = field.replace(/"/g, '""');
		// Wrap the field in double quotes
		field = `"${field}"`;
	}
	return field;
};

export default escapeCsvField;
